export const curriculumCollectionId = ["neCurriculums", "eeCurriculums"] as const;
export type CurriculumCollectionId = typeof curriculumCollectionId[number];

export function isCurriculumCollectionId(str: string): str is CurriculumCollectionId {
  return curriculumCollectionId.some(v => v === str);
}
